const PROXY_URL = 'https://pp.movemaestro.com/v3/mmapi/'; 
const TWS_LOGIN = 'https://tolltwsfunctions-st.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctions-st.azurewebsites.net/api/TWSForgotLogin'; 
const TWS_REGISTER = 'https://tolltwsfunctions-st.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctions-st.azurewebsites.net/api/twsregister?client=civilian'; 
const QAS = 'https://tolltwsfunctions-st.azurewebsites.net/api/QAS'; 
const AAD = 'amovemaestro.onmicrosoft.com';
const USE_OLD_LOGIN = true;
const USE_REDIRECT = false;
const LOGIN_CLIENT_ID = '200ba25f-4605-49e3-aeb8-5fb20198e4d2';
const LOGIN_SCOPE = 'https://aa.movemaestro.com/.default';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
    ,USE_OLD_LOGIN
    ,USE_REDIRECT
    ,LOGIN_CLIENT_ID
    ,LOGIN_SCOPE
}